/* eslint-disable */
import * as Types from '../../../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetHotelRmDataQueryVariables = Types.Exact<{
  args: Types.RmDataArgs;
}>;


export type GetHotelRmDataQuery = { __typename?: 'Query', rmData?: Array<{ __typename?: 'RmData', adr?: number | null, adr_ly?: number | null, adr_ly_final?: number | null, brand_code?: any | null, capacity?: number | null, capacity_ly?: number | null, capacity_ly_final?: number | null, compadr_py?: number | null, compocc_py?: number | null, comprevpar_py?: number | null, date_day?: string | null, date_dom?: string | null, date_month?: string | null, date_quarter?: string | null, date_week?: string | null, date_ydw?: string | null, date_year?: string | null, date_year_ny?: string | null, date_ym?: string | null, date_ym_ny?: string | null, date_yq?: string | null, date_yq_ny?: string | null, date_yw?: string | null, date_yw_ny?: string | null, delta_1day?: number | null, delta_3day?: number | null, delta_7day?: number | null, dow?: string | null, group_adr?: number | null, group_adr_ly_final?: number | null, group_blocked?: number | null, group_pu_14day?: number | null, group_pu_1day?: number | null, group_pu_2day?: number | null, group_pu_30day?: number | null, group_pu_3day?: number | null, group_pu_4day?: number | null, group_pu_5day?: number | null, group_pu_6day?: number | null, group_pu_7day?: number | null, group_revenue?: number | null, group_revenue_ly_final?: number | null, group_revpar?: number | null, group_sold?: number | null, group_sold_ly?: number | null, group_sold_ly_final?: number | null, last_transient_bkg_dt?: any | null, lvl_a_details?: string | null, lvl_a_occ?: number | null, lvl_a_remaining?: number | null, lvl_a_sold?: number | null, lvl_a_status?: string | null, lvl_b_details?: string | null, lvl_b_occ?: number | null, lvl_b_remaining?: number | null, lvl_b_sold?: number | null, lvl_b_status?: string | null, lvl_c_details?: string | null, lvl_c_occ?: number | null, lvl_c_remaining?: number | null, lvl_c_sold?: number | null, lvl_c_status?: string | null, lvl_d_details?: string | null, lvl_d_occ?: number | null, lvl_d_remaining?: number | null, lvl_d_sold?: number | null, lvl_d_status?: string | null, lvl_e_details?: string | null, lvl_e_occ?: number | null, lvl_e_remaining?: number | null, lvl_e_sold?: number | null, lvl_e_status?: string | null, lvl_f_details?: string | null, lvl_f_occ?: number | null, lvl_f_remaining?: number | null, lvl_f_sold?: number | null, lvl_f_status?: string | null, lvl_g_details?: string | null, lvl_g_occ?: number | null, lvl_g_remaining?: number | null, lvl_g_sold?: number | null, lvl_g_status?: string | null, lvl_h_details?: string | null, lvl_h_occ?: number | null, lvl_h_remaining?: number | null, lvl_h_sold?: number | null, lvl_h_status?: string | null, occ?: number | null, occ_ly?: number | null, occ_ly_final?: number | null, occ_rc?: number | null, ooo?: number | null, ooo_ly?: number | null, ooo_ly_final?: number | null, pace_var?: number | null, policy_cd?: string | null, pu_14day?: number | null, pu_1day?: number | null, pu_1day_ly?: number | null, pu_2day?: number | null, pu_30day?: number | null, pu_3day?: number | null, pu_3day_ly?: number | null, pu_4day?: number | null, pu_5day?: number | null, pu_6day?: number | null, pu_7day?: number | null, pu_7day_ly?: number | null, pu_dayofarr?: number | null, pu_dayofarr_ly?: number | null, rate?: number | null, remaining?: number | null, remaining_ly?: number | null, remaining_ly_final?: number | null, revenue?: number | null, revenue_ly?: number | null, revenue_ly_final?: number | null, revpar?: number | null, revpar_ly?: number | null, revpar_ly_final?: number | null, rooms_committed?: number | null, snapshot_date?: any | null, snapshot_date_ly?: any | null, sold?: number | null, sold_ly?: number | null, sold_ly_final?: number | null, stay_date?: any | null, stay_date_ly?: any | null, stay_date_ny?: any | null, total_capacity?: number | null, total_capacity_ly?: number | null, total_capacity_ly_final?: number | null, total_potential_group?: number | null, total_sold?: number | null, transient_adr?: number | null, transient_l7_bkg_days?: number | null, transient_revenue?: number | null, transient_sold?: number | null, transient_sold_ly?: number | null, transient_sold_ly_final?: number | null, transient_sold_ly_final_n?: number | null, transient_sold_ly_n?: number | null, var_adr_ly?: number | null, var_adr_ly_final?: number | null, var_adr_ly_final_n?: number | null, var_adr_ly_n?: number | null, var_capacity_ly?: number | null, var_capacity_ly_final?: number | null, var_group_revenue_ly_final?: number | null, var_group_sold_ly?: number | null, var_group_sold_ly_final?: number | null, var_occ_ly?: number | null, var_occ_ly_final?: number | null, var_ooo_ly?: number | null, var_ooo_ly_final?: number | null, var_remaining_ly?: number | null, var_remaining_ly_final?: number | null, var_revenue_ly?: number | null, var_revenue_ly_final?: number | null, var_revenue_ly_final_n?: number | null, var_revenue_ly_n?: number | null, var_revpar_ly?: number | null, var_revpar_ly_final?: number | null, var_sold_ly?: number | null, var_sold_ly_final?: number | null, var_sold_ly_final_n?: number | null, var_sold_ly_n?: number | null, var_total_capacity_ly?: number | null, var_total_capacity_ly_final?: number | null, var_transient_sold_ly?: number | null, var_transient_sold_ly_final?: number | null } | null> | null };


export const GetHotelRmDataDocument = gql`
    query GetHotelRmData($args: RmDataArgs!) {
  rmData(args: $args) {
    adr
    adr_ly
    adr_ly_final
    brand_code
    capacity
    capacity_ly
    capacity_ly_final
    compadr_py
    compocc_py
    comprevpar_py
    date_day
    date_dom
    date_month
    date_quarter
    date_week
    date_ydw
    date_year
    date_year_ny
    date_ym
    date_ym_ny
    date_yq
    date_yq_ny
    date_yw
    date_yw_ny
    delta_1day
    delta_3day
    delta_7day
    dow
    group_adr
    group_adr_ly_final
    group_blocked
    group_pu_14day
    group_pu_1day
    group_pu_2day
    group_pu_30day
    group_pu_3day
    group_pu_4day
    group_pu_5day
    group_pu_6day
    group_pu_7day
    group_revenue
    group_revenue_ly_final
    group_revpar
    group_sold
    group_sold_ly
    group_sold_ly_final
    last_transient_bkg_dt
    lvl_a_details
    lvl_a_occ
    lvl_a_remaining
    lvl_a_sold
    lvl_a_status
    lvl_b_details
    lvl_b_occ
    lvl_b_remaining
    lvl_b_sold
    lvl_b_status
    lvl_c_details
    lvl_c_occ
    lvl_c_remaining
    lvl_c_sold
    lvl_c_status
    lvl_d_details
    lvl_d_occ
    lvl_d_remaining
    lvl_d_sold
    lvl_d_status
    lvl_e_details
    lvl_e_occ
    lvl_e_remaining
    lvl_e_sold
    lvl_e_status
    lvl_f_details
    lvl_f_occ
    lvl_f_remaining
    lvl_f_sold
    lvl_f_status
    lvl_g_details
    lvl_g_occ
    lvl_g_remaining
    lvl_g_sold
    lvl_g_status
    lvl_h_details
    lvl_h_occ
    lvl_h_remaining
    lvl_h_sold
    lvl_h_status
    occ
    occ_ly
    occ_ly_final
    occ_rc
    ooo
    ooo_ly
    ooo_ly_final
    pace_var
    policy_cd
    pu_14day
    pu_1day
    pu_1day_ly
    pu_2day
    pu_30day
    pu_3day
    pu_3day_ly
    pu_4day
    pu_5day
    pu_6day
    pu_7day
    pu_7day_ly
    pu_dayofarr
    pu_dayofarr_ly
    rate
    remaining
    remaining_ly
    remaining_ly_final
    revenue
    revenue_ly
    revenue_ly_final
    revpar
    revpar_ly
    revpar_ly_final
    rooms_committed
    snapshot_date
    snapshot_date_ly
    sold
    sold_ly
    sold_ly_final
    stay_date
    stay_date_ly
    stay_date_ny
    total_capacity
    total_capacity_ly
    total_capacity_ly_final
    total_potential_group
    total_sold
    transient_adr
    transient_l7_bkg_days
    transient_revenue
    transient_sold
    transient_sold_ly
    transient_sold_ly_final
    transient_sold_ly_final_n
    transient_sold_ly_n
    var_adr_ly
    var_adr_ly_final
    var_adr_ly_final_n
    var_adr_ly_n
    var_capacity_ly
    var_capacity_ly_final
    var_group_revenue_ly_final
    var_group_sold_ly
    var_group_sold_ly_final
    var_occ_ly
    var_occ_ly_final
    var_ooo_ly
    var_ooo_ly_final
    var_remaining_ly
    var_remaining_ly_final
    var_revenue_ly
    var_revenue_ly_final
    var_revenue_ly_final_n
    var_revenue_ly_n
    var_revpar_ly
    var_revpar_ly_final
    var_sold_ly
    var_sold_ly_final
    var_sold_ly_final_n
    var_sold_ly_n
    var_total_capacity_ly
    var_total_capacity_ly_final
    var_transient_sold_ly
    var_transient_sold_ly_final
  }
}
    `;

/**
 * __useGetHotelRmDataQuery__
 *
 * To run a query within a React component, call `useGetHotelRmDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHotelRmDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHotelRmDataQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useGetHotelRmDataQuery(baseOptions: Apollo.QueryHookOptions<GetHotelRmDataQuery, GetHotelRmDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHotelRmDataQuery, GetHotelRmDataQueryVariables>(GetHotelRmDataDocument, options);
      }
export function useGetHotelRmDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHotelRmDataQuery, GetHotelRmDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHotelRmDataQuery, GetHotelRmDataQueryVariables>(GetHotelRmDataDocument, options);
        }
export type GetHotelRmDataQueryHookResult = ReturnType<typeof useGetHotelRmDataQuery>;
export type GetHotelRmDataLazyQueryHookResult = ReturnType<typeof useGetHotelRmDataLazyQuery>;
export type GetHotelRmDataQueryResult = Apollo.QueryResult<GetHotelRmDataQuery, GetHotelRmDataQueryVariables>;
export const namedOperations = {
  Query: {
    GetHotelRmData: 'GetHotelRmData'
  }
}